export const findIndexOfItem = (array, value) => {
  return array.findIndex((e) => e === value);
};

export const idExistsInArray = (array, id) => {
  const index = array.findIndex((e) => e.id === id);
  if (index >= 0) {
    return true;
  } else {
    return false;
  }
};

export const returnArrayObject = (array, id) => {
  let index = array.findIndex((e) => e.id === id);
  let details = array[index];
  //   console.log(details);
  return details;
};

export const returnPublishOption = (array, value) => {
  let index = array.findIndex((e) => e.value === value);
  let details = array[index];
  //   console.log(details);
  return details;
};

export const removeItemAtIndex = (arr, index) => {
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
};

export const removeArrayEntry = (array, item) => {
  try {
    if (item.id) {
      let index = array.findIndex(
        (e) => e._id.toString() === item.id.toString(),
      );

      // remove the entry with that value
      array.splice(index, 1);
    } else {
      let index = array.findIndex(
        (e) => e._id.toString() === item._id.toString(),
      );

      // remove the entry with that value
      array.splice(index, 1);
    }

    // return the new array
    return array;
  } catch (error) {
    console.log("error in removeArrayEntry");
    console.log(error);
  }
};

export const updateObjectInArray = (array, index, newValue) => {
  // let clone = structuredClone(array);
  let clone = JSON.parse(JSON.stringify(array));
  clone[index] = newValue;
  return clone;
};

export const removeFromArray = (array, index) => {
  // let clone = structuredClone(array);
  let clone = JSON.parse(JSON.stringify(array));
  clone.splice(index, 1);
  return clone;
};

export const removePlugin = (array, value) => {
  const index = array.findIndex((e) => e.id === value.id);
  let clone = JSON.parse(JSON.stringify(array));
  clone.splice(index, 1);
  return clone;
};

export const updatePluginInArray = (array, newValue) => {
  const index = array.findIndex((e) => e.id === newValue.id);
  let clone = JSON.parse(JSON.stringify(array));
  clone[index] = newValue;
  return clone;
};

export const getSubheadingByGroupId = (groupIdToFind, arrayOfObjects) => {
  if (arrayOfObjects) {
    const foundObject = arrayOfObjects.find((e) => e.groupId === groupIdToFind);
    return foundObject ? foundObject.subheading : "";
  } else {
    return "";
  }
};

export const getAnnotationsByGroupId = (groupIdToFind, arrayOfObjects) => {
  if (arrayOfObjects) {
    const foundObject = arrayOfObjects.find((e) => e.groupId === groupIdToFind);
    return foundObject ? foundObject.annotations : "";
  } else {
    return "";
  }
};

export const getParentByGroupId = (groupIdToFind, arrayOfObjects) => {
  if (arrayOfObjects) {
    const foundObject = arrayOfObjects.find(
      (e) => e.groupId.toString() === groupIdToFind.toString(),
    );
    return foundObject ? foundObject.parentGroup : "";
  } else {
    return "";
  }
};

export const getParentGroupName = (groupIdToFind, arrayOfObjects) => {
  if (arrayOfObjects) {
    const foundObject = arrayOfObjects.find(
      (e) => e._id.toString() === groupIdToFind.toString(),
    );
    if (foundObject.parentGroup) {
      const foundParent = arrayOfObjects.find(
        (e) => e._id.toString() === foundObject.parentGroup.toString(),
      );
      if (foundParent) {
        return foundParent.name;
      } else {
        return "";
      }
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export const getNameByGroupId = (
  groupIdToFind,
  arrayOfObjects,
  currentName,
) => {
  if (arrayOfObjects) {
    const foundObject = arrayOfObjects.find((e) => e.groupId === groupIdToFind);
    return foundObject && foundObject.groupTitle?.length > 0
      ? foundObject.groupTitle
      : currentName;
  } else {
    return currentName;
  }
};

export const getGroupOrderNumber = (arrayOfObjects, groupIdToFind) => {
  if (groupIdToFind) {
    const foundIndex = arrayOfObjects.findIndex(
      (e) => e.id.toString() === groupIdToFind.toString(),
    );
    return foundIndex + 1;
  } else {
    console.log(groupIdToFind);
    console.log("nope");
  }
};

export const hasGroupTitle = (groupIdToFind, arrayOfObjects) => {
  return arrayOfObjects.some(
    (e) =>
      e.groupId.toString() === groupIdToFind.toString() &&
      e.groupTitle &&
      e.groupTitle.length > 0,
  );
};

export const getTitleByGroupId = (groupIdToFind, arrayOfObjects) => {
  const foundObject = arrayOfObjects.find((e) => e.groupId === groupIdToFind);
  return foundObject ? foundObject.groupTitle : "";
};

export const getMinutesInfoByGroupId = (groupIdToFind, arrayOfObjects) => {
  for (let i = 0; i < arrayOfObjects.length; i++) {
    if (arrayOfObjects[i].groupId === groupIdToFind) {
      if (arrayOfObjects[i].minutesInfo) {
        return arrayOfObjects[i].minutesInfo;
      } else {
        return "";
      }
    }
  }
  // Return a default value (e.g., an empty string) if the groupId is not found.
  return "";
};

export const getGroupSubheadingInfo = (groupIdToFind, arrayOfObjects) => {
  if (arrayOfObjects) {
    const foundObject = arrayOfObjects.find((e) => e.groupId === groupIdToFind);
    if (foundObject) {
      return foundObject;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export const recordTypes = [
  "Administrative Appeal",
  "Alcoholic Beverage Permit",
  "Annexation",
  "Certificate of Appropriateness",
  "Comprehensive Plan Amendment",
  "Conditional Use Permit",
  "Demolition Permit",
  "Development Plan",
  "Economic Development Agreement",
  "Final Plat",
  "First Reading",
  "General",
  "Historic Landmark Designation",
  "Ordinance",
  "Preliminary Plat",
  "Replat",
  "Resolution",
  "Right-of-Way Abandonment",
  "Second Reading",
  "Sign Variance",
  "Site Plan",
  "Special Exception",
  "Special Use Permit",
  "Specific Use Permit",
  "Tax Abatement Agreement",
  "Variance",
  "Zoning Case",
];
